import type { PackageManager } from '@cli-types/core-engine/utils.js'

export const BETTERSTART_DIR = '.betterstart'
export const CONFIG_FILE_NAME = 'betterstart.config.ts'
export const DEVELOPMENT_ENV_FILES = [
  '.env.development.local',
  '.env.local',
  '.env.development',
  '.env'
] as const
export const LOCKFILE_MAP: Record<string, PackageManager> = {
  'pnpm-lock.yaml': 'pnpm',
  'package-lock.json': 'npm',
  'yarn.lock': 'yarn',
  'bun.lockb': 'bun',
  'bun.lock': 'bun'
}
